import OpeningService from '@/services/openingService'
import { Promise } from 'core-js'

// state
const state = {
  selectedOpening: null,
  showOpeningModal: false
}

// getters
const getters = {
  selectedOpening: state => state.selectedOpening,
  showOpeningModal: state => state.showOpeningModal
}

// actions
const actions = {
  //   getLastModificationForBuildings({ commit }, buildings) {
  //     return new Promise((resolve, reject) => {
  //       buildings.forEach(element => {
  //         ProjectService.getLastModificationForBuilding(element.buildingId).then(res => {
  //           element.lastModification = res.data
  //         })
  //       })
  //       resolve(buildings)
  //     })
  //   }
}

// mutations
const mutations = {
  SHOW_OPENING_MODAL(state, value) {
    state.showOpeningModal = false
  },
  SET_SELECTED_OPENING(state, opening) {
    state.selectedOpening = opening
    state.showOpeningModal = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/opening.js